import LineGiftIcon from 'LuxKit/Icons/line/LineGiftIcon'
import LineUsdCircleIcon from 'LuxKit/Icons/line/LineUsdCircleIcon'
import LabeledSheet from 'LuxKit/LabeledSheet'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import React from 'react'
import FormatCurrency from '../FormatCurrency'
import useCurrentSiteTakeover from 'hooks/useCurrentSiteTakeover'
import styled from 'styled-components'
import { rem } from 'polished'
import Label from 'LuxKit/Label'

const TakeoverSheet = styled(LabeledSheet)`
  && > * {
    border-color: var(--takeover-primary);
  }
`

const Content = styled.div`
  padding: ${rem(20)};
`

function LunarSiteTakeoverOfferUSPs() {
  const siteTakeover = useCurrentSiteTakeover({ vertical: 'hotel' })

  if (!siteTakeover) {
    return null
  }

  return <TakeoverSheet
    kind="highlight"
    label={<Label
      kind="primary"
      variant="critical"
      style={{ backgroundColor: siteTakeover.primaryColour }}
    >
      Lunar new year 2025
    </Label>}
    style={{ '--takeover-primary': siteTakeover.primaryColour }}
  >
    <Content>
      <BodyTextBlock variant="medium" colour="neutral-two" startIcon={<LineUsdCircleIcon />}>
        Enjoy exclusive discounted prices
      </BodyTextBlock>
      <BodyTextBlock variant="medium" colour="neutral-two" startIcon={<LineGiftIcon />}>
        Join the draw to win! 3 lucky winners get a free getaway,{' '}
        and 3 more win <FormatCurrency currency="USD" value={350} /> credit
      </BodyTextBlock>
    </Content>
  </TakeoverSheet>
}

export default LunarSiteTakeoverOfferUSPs
